import { Component, Vue } from "vue-property-decorator";
import qNotify from "@/common/qNotify";
import {namespace} from "vuex-class";
const authStore = namespace("Auth");

@Component
class Authority extends Vue {
  @authStore.Getter
  public isCustomer;

  public checkAuthor() {
    if(this.$route.meta.permission) {
      return this.$ability.can(...this.$route.meta.permission);
    }
    return true;
  }

  beforeMount() {
    if(!this.checkAuthor()) {
      if(this.isCustomer) {
        this.$router.push({ name: "customer.home" });
      } else {
        this.$router.push({ name: "admin.dashboard" });
      }

      qNotify.error({
        text: this.$t("router_not_permission"),
      });
    }
  }
}
export default Authority;
